export default __webpack_public_path__ + "static/media/vianney.774e04ed.png";